import classNames from "classnames"
import React from "react"

import CircledIconButton from "../../elements/V2/Buttons/CircledIconButton"
import GatsbyStoryblokImage from "../../elements/V2/GatsbyStoryblokImage"
import Section from "../../elements/V2/Section"
import LayoutItem from "../Layouts/LayoutItem"

import { getBackgroundColorClass } from "@utils/V2/color"
import { Color } from "constants/V2/color"

type Props = {
  backgroundColor: Color
  imageUrl: string
  imageAlt: string
  buttonColor: Color
  buttonLink: string | YocoCom.YocoLink
  rounded?: boolean
  mobileGridOrder?: number
}

const CentreCTA = ({
  backgroundColor,
  imageUrl,
  imageAlt,
  buttonColor,
  buttonLink,
  rounded = true,
  mobileGridOrder,
  ...props
}: Props) => {
  return (
    <LayoutItem
      as={Section}
      className={classNames(
        getBackgroundColorClass(backgroundColor),
        "pb-lg -mb-lg relative flex items-center justify-center gap-x-8 overflow-hidden md:gap-x-16 lg:gap-x-24",
        {
          "rounded-t-xl -mt-xl": rounded,
        }
      )}
      mobileGridOrder={mobileGridOrder}
      {...props}
    >
      <GatsbyStoryblokImage
        aspectRatio="fullWidth"
        loadType="eager"
        image={imageUrl}
        alt={imageAlt || "CTA Image"}
        className="aspect-[5.2/1] h-64 md:h-72 lg:h-88"
      />
      <CircledIconButton
        color={buttonColor}
        linkUrl={buttonLink}
        style="bordered"
      />
    </LayoutItem>
  )
}

export default CentreCTA
